/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, ToastController} from 'ionic-angular';
import {LotteryPage} from "../lottery/lottery";
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {ReportWinLossDetailsPage} from "../reportWinLossDetails/reportWinLossDetails";
import { AppDialog } from "../../component/appDialog";

@Component({
    templateUrl: 'reportWinLossList.html',
    selector: 'report-win-loss-list-page',
})
export class ReportWinLossListPage {
    private recordList: any = [];
    requestData: any;

    constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController,
                private toastCtrl: ToastController) {
        this.requestData = navParams.get("requestData");
        this.dealData(navParams.get("data"));
    }

    goDetail(item: any) {
        this.nav.push(ReportWinLossDetailsPage, {
            data: item,
            type: 1
        });
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = {
            order: this.requestData["order"],
            loginname: this.requestData["loginname"],
            stime: this.requestData["stime"],
            etime: this.requestData["etime"]
        };
        this.userService.reportWinLossSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.dealData(data);
            }else {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: data["msg"]
                });
            }
            if (refresher) {
                refresher.complete();
            }
        });
    }

    /**
     * 处理返回数据
     * @param data
     */
    dealData(data: any) {
        let parentAr: any = [data["ruitem"]];
        this.recordList = parentAr.concat(data["reportmain"]);
        this.recordList.map(item => {
            item["fd"] = (item["fd"]).toFixed(4);
            item["saletz"] = item["saletz"].toFixed(4);
            return item;
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/reportWinLossList/reportWinLossList.ts